<div class="timeline-block">
  <ins
    class="adsbygoogle"
    style="display:inline-block;width:468px;height:60px"
    data-ad-client="ca-pub-4733833642011475"
    data-ad-slot="8828886259"
  ></ins>
</div>



// WEBPACK FOOTER //
// ./src/app/rec/timeline/timeline-block/timeline-block.component.html